/**
 * Checks if the application is currently running in a prerendering environment.
 * This is determined by the presence of a global `window.IS_PRERENDERING` flag,
 * which is injected by the prerendering script (e.g., Puppeteer).
 *
 * @returns {boolean} `true` if in a prerendering environment, otherwise `false`.
 */
export const isPrerendering = (): boolean => {
  return typeof window !== 'undefined' && (window as any).IS_PRERENDERING === true;
};
